module.exports = __webpack_public_path__ + "img/work_icon.09b09648.png";